export default __webpack_public_path__ + "static/media/error.9c02e504.jpg";